import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../../config/axios';
import '../order/OrderPayment.css';

const GroupPaymentSuccess: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const sessionCode = params.get('sessionCode');
    const resultCode = params.get('resultCode');
    const paymentId = params.get('paymentId');
    const amount = params.get('amount');

    if (!sessionCode) {
      setError('Không tìm thấy thông tin session');
      setLoading(false);
      return;
    }

    const processPayment = async () => {
      try {
        const res = await api.post('/api/group-orders/momo-payment', {
          sessionCode,
          resultCode: parseInt(resultCode || '0'),
          paymentId,
          amount: parseFloat(amount || '0')
        });

        if (res.data.success) {
          setSuccess('Thanh toán MoMo thành công!');
          setTimeout(() => {
            navigate('/orders/payment-success', { 
              state: { 
                order: res.data.data,
                isGroupOrder: true,
                groupInfo: {
                  sessionCode: res.data.data.sessionCode,
                  orderCount: res.data.data.orderCount,
                  paidBy: 'Thanh toán MoMo'
                }
              }
            });
          }, 3000);
        } else {
          setError('Thanh toán thất bại');
        }
      } catch (err: any) {
        setError(err.response?.data?.message || 'Lỗi xử lý thanh toán');
      } finally {
        setLoading(false);
      }
    };

    processPayment();
  }, [location.search, navigate]);

  if (loading) {
    return (
      <div className="order-payment-bg">
        <div className="order-payment-container">
          <div className="order-payment-loading">Đang xử lý thanh toán...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="order-payment-bg">
      <div className="order-payment-container">
        {error ? (
          <>
            <div className="payment-success-icon" style={{ color: '#ef4444' }}>❌</div>
            <h2 className="payment-success-title" style={{ color: '#ef4444' }}>Thanh toán thất bại</h2>
            <div className="payment-success-message">{error}</div>
            <button 
              onClick={() => navigate('/orders/group-join')}
              className="order-payment-submit-btn"
              style={{ width: '100%', marginTop: 16 }}
            >
              Thử lại
            </button>
          </>
        ) : (
          <>
            <div className="payment-success-icon">✅</div>
            <h2 className="payment-success-title">Thanh toán MoMo thành công!</h2>
            <div className="payment-success-message">
              Cảm ơn quý khách đã thanh toán thành công qua MoMo!
            </div>
            <div className="payment-success-message">
              Đang chuyển đến trang xác nhận...
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default GroupPaymentSuccess; 